<app-breadcrumb
	[badge]="badge"
	[breadcrumb]="breadcrumb"></app-breadcrumb>
<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="card"
	*ngIf="project?.reporting">
	<div
		class="card-body"
		[style.min-height]="10">
		<div class="text-center">
			<h5>
				{{'labels.reporting-monitoring' | translate}}:

				{{progressBarCurrent | currency: '€'}} / {{progressBarMax | currency: '€'}}
			</h5>
		</div>
		<p>
			<ngb-progressbar
				type="primary"
				[value]="progressBarCurrent / progressBarMax * 100"
				[striped]="true"
				[animated]="true">
				{{(progressBarCurrent / progressBarMax * 100) | number : '1.2-2' }} %
			</ngb-progressbar>
		</p>
	</div>
</div>

<div class="d-flex justify-content-center">

	<div
		*ngFor="let key of project?.costperactivitytaxonomy | keys"
		class="card col-3 ml-2 mr-2 text-center">
		<div
			class="card-body"
			[style.min-height]="20">
			<h5>{{'labels.' + key | translate}}</h5>
			<h6>
				{{project?.costperactivitytaxonomy[key] / 100 | currency: '€'}}
			</h6>
			<h6>
				{{project?.costperactivitytaxonomy[key] / project?.totcostperactivity * 100 | number: '1.0-0'}} %
			</h6>
		</div>
	</div>

</div>

<div
	class="row min-height"
	*ngIf="!loading && project && tender">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">
			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container
					ngbNavItem="dati"
					id="1">

					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>

						<table
							class="table"
							*ngIf="project">
							<tbody>
								<tr *ngIf="project.id">
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ project.id }}</td>
								</tr>
								<tr *ngIf="project.name">
									<td>{{ 'labels.name' | translate }}</td>
									<td>{{ project.name }}</td>
								</tr>

								<tr *ngIf="project.companyname">
									<td>{{'labels.company' | translate }}</td>
									<td>{{ project.companyname }}</td>
								</tr>

								<tr *ngIf="project.tendername">
									<td>{{'labels.tender' | translate }}</td>
									<td>
										<a
											routerLink="/tender/view/{{project?.tender?.id}}"
											class="link"
											ngbTooltip="{{'labels.details' | translate}}">
											{{ project.tendername }}
										</a>
									</td>
								</tr>

								<tr *ngIf="project.budget">
									<td>{{'labels.budget' | translate }}</td>
									<td>{{ project.budget | currency:'EUR' }}</td>
								</tr>
								<tr *ngIf="project.startdate">
									<td>{{'labels.startdate' | translate }}</td>
									<td>
										{{ project.startdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr *ngIf="project.enddate">
									<td>{{'labels.enddate' | translate }}</td>
									<td>
										{{ project.enddate | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr *ngIf="project.senddate">
									<td>{{'labels.senddate' | translate }}</td>
									<td>
										{{ project.senddate | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr *ngFor="let key of keys">
									<td>{{'labels.'+ key | translate }}</td>
									<td>{{ project[key] }}</td>
								</tr>

								<tr *ngIf="project.insdate">
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ project.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<tr *ngIf="project.moddate">
									<td>{{'labels.moddate' | translate }}</td>
									<td>
										{{ project.moddate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>

							</tbody>
						</table>

						<h5>{{'labels.description' | translate}}</h5>
						<div [innerHTML]="project.description"></div>

						<div class="row mt-1">
							<div class="col">
								<button
									(click)="edit()"
									class="btn btn-primary"
									*ngIf="project.isDraft || !isCompany">
									{{'labels.edit' | translate}}
								</button>
							</div>
							<div class="col-md-9 pull-right">
								<button
									(click)="openFileGeneratorModal(fileGeneratorModal)"
									class="btn btn-default ml-1"
									*ngIf="project.isPresented || project.isClosed">
									{{'labels.download-project' | translate}}
								</button>
								<button
									(click)="present()"
									class="btn btn-primary"
									*ngIf="project.isDraft && !isCompany">
									{{'labels.presentproject' | translate}}
								</button>

								<button
									(click)="close()"
									class="btn btn-primary ml-1"
									*ngIf="project.isPresented && !isCompany">
									{{'labels.close' | translate}}
								</button>

								<button
									(click)="reject()"
									class="btn btn-danger ml-1"
									*ngIf="project.isPresented && !isCompany">
									{{'labels.reject' | translate}}
								</button>

								<button
									(click)="archive()"
									class="btn btn-warning ml-1"
									*ngIf="!isCompany && project.status != 'archived'">
									{{'labels.archive' | translate}}
								</button>

							</div>

						</div>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="dettagli">

					<a
						routerLink="."
						fragment="dettagli"
						ngbNavLink>
						Dettagli
					</a>
					<ng-template ngbNavContent>

						<ng-template [ngIf]="!projectdata">
							<h5>
								{{'labels.enter-project-details' | translate}}
							</h5>
						</ng-template>

						<ng-template [ngIf]="projectdata && projectdata.jsondata">
							<ng-template
								ngFor
								let-k
								[ngForOf]="projectdatakeys">
								<h6>{{'project.' + k | translate}}</h6>
								<div [innerHTML]="projectdata.jsondata[k]"></div>
							</ng-template>
						</ng-template>

						<h6 *ngIf="projectdata && projectdata.jsondata">
							{{'project.consistency.title' | translate}}
						</h6>
						<ul *ngIf="projectdata && projectdata.jsondata">
							<li *ngFor="let k of projectdata.jsondata['consistency']">
								{{'project.consistency.' + k | translate}}
							</li>
						</ul>
						<p *ngIf="projectdata && projectdata.jsondata && !projectdata.jsondata['consistency'].length">{{'labels.none' | translate}}</p>

						<h6 *ngIf="projectdata && projectdata.jsondata">
							{{'project.objective.title' | translate}}
						</h6>
						<ul *ngIf="projectdata && projectdata.jsondata">
							<ng-template
								ngFor
								let-k
								[ngForOf]="projectdata.jsondata['objective']">
								<ng-template [ngIf]="k !== 'other'">
									<li>
										{{'project.objective.' + k | translate}}
									</li>
								</ng-template>
							</ng-template>
							<li *ngIf="projectdata.jsondata['otherobjective']">
								{{projectdata.jsondata['otherobjective']}}
							</li>

						</ul>
						<p *ngIf="projectdata && projectdata.jsondata && !projectdata.jsondata['objective'].length">{{'labels.none' | translate}}</p>

						<div class="row mt-1">
							<div class="col">
								<button
									routerLink="/project/edit/data/{{project.id}}"
									class="btn btn-primary"
									*ngIf="project.isDraft">
									{{'labels.edit' | translate}}
								</button>

							</div>

						</div>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="obiettivi">
					<a
						routerLink="."
						ngbNavLink
						fragment="obiettivi">
						Obiettivi operativi
					</a>

					<ng-template ngbNavContent>
						<app-objective-list
							[projectid]="project.id"
							[usercompanyid]="usercompanyid"></app-objective-list>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="partecipanti">

					<a
						ngbNavLink
						routerLink="."
						fragment="partecipanti">
						Partecipanti
					</a>
					<ng-template ngbNavContent>
						<app-partecipant-list
							[projectid]="project.id"
							[usercompanyid]="usercompanyid"
							(onAddPartecipant)="addPartecipant($event)"
							(onDeletePartecipant)="deletePartecipant($event)"></app-partecipant-list>
					</ng-template>
				</ng-container>

				<ng-template
					ngFor
					let-partecipant
					let-i="index"
					[ngForOf]="partecipants">
					<ng-container
						ngbNavItem="partecipant-{{i}}"
						*ngIf="!isCompany || (partecipant.entity == partecipantType.COMPANY && partecipant.entityobj.id == usercompanyid)">

						<a
							routerLink="."
							fragment="partecipant-{{i}}"
							ngbNavLink>
							{{partecipant.name}}
						</a>

						<ng-template ngbNavContent>

							<ng-template [ngIf]="partecipant.entity == partecipantType.CONSULTANT">
								<nav
									ngbNav
									#nav3="ngbNav"
									class="nav-pills">

									<ng-container
										*ngIf="tender.hrresources"
										ngbNavItem>
										<a ngbNavLink>Associa Risorse</a>
										<ng-template ngbNavContent>
											<app-project-consultants
												[consultantid]="partecipant.entityobj.id"
												[projectid]="project.id"></app-project-consultants>
										</ng-template>
									</ng-container>
									<ng-container ngbNavItem>
										<a ngbNavLink>Allegati domanda</a>
										<ng-template ngbNavContent>

											<app-attachments
												[readonly]="!project?.isDraft"
												[card]="false"
												mediapath="download"
												entity="partecipant"
												[bootstrap]="true"
												[eid]="partecipant.id"></app-attachments>

										</ng-template>
									</ng-container>

								</nav>
								<div
									[ngbNavOutlet]="nav3"
									class="mt-2"></div>
							</ng-template>
							<ng-template [ngIf]="partecipant.entity == partecipantType.COMPANY">
								<nav
									ngbNav
									#nav2="ngbNav"
									class="nav-pills">

									<ng-container
										*ngIf="tender.hrresources"
										ngbNavItem="companyresources">
										<a ngbNavLink>Risorse</a>
										<ng-template ngbNavContent>
											<app-project-employee-list
												[tenderid]="project.tenderid"
												[companyid]="partecipant.entityobj?.id"
												[projectid]="project.id"></app-project-employee-list>
										</ng-template>
									</ng-container>
									<ng-container
										*ngIf="tender.hrresources"
										ngbNavItem>
										<a ngbNavLink>Associa Risorse</a>
										<ng-template ngbNavContent>
											<app-objective-resources
												(goto)="opentab(true, $event)"
												[companyid]="partecipant.entityobj?.id"
												[projectid]="project.id"></app-objective-resources>
										</ng-template>
									</ng-container>
									<ng-container
										*ngIf="tender.hrresources"
										ngbNavItem>
										<a ngbNavLink>Risorse su mesi</a>
										<ng-template ngbNavContent>
											<app-hours-resources
												(goto)="opentab(true, $event)"
												[companyid]="partecipant.entityobj?.id"
												[projectid]="project.id"></app-hours-resources>
										</ng-template>
									</ng-container>
									<ng-container
										*ngIf="tender.tools"
										ngbNavItem>
										<a ngbNavLink>Strumentazioni</a>
										<ng-template ngbNavContent>
											<app-project-tools
												[companyid]="partecipant.entityobj?.id"
												[projectid]="project.id"></app-project-tools>
										</ng-template>
									</ng-container>
									<ng-container
										*ngIf="tender.buildings"
										ngbNavItem>
										<a ngbNavLink>Terreni e fabbricati</a>
										<ng-template ngbNavContent>
											<app-project-buildings
												[companyid]="partecipant.entityobj?.id"
												[projectid]="project.id"></app-project-buildings>
										</ng-template>
									</ng-container>
									<ng-container
										ngbNavItem
										*ngIf="showgeneralcosts && tender.othercosts">
										<a ngbNavLink>Altri costi</a>
										<ng-template ngbNavContent>
											<app-project-costs-list
												[companyid]="partecipant.entityobj?.id"
												[projectid]="project.id"></app-project-costs-list>
										</ng-template>
									</ng-container>
									<ng-container ngbNavItem>
										<a ngbNavLink>Allegati domanda</a>
										<ng-template ngbNavContent>
											<app-attachments
												[extradata]="{'company' : partecipant.entityobj?.id}"
												[readonly]="!project?.isDraft"
												[card]="false"
												mediapath="download"
												entity="partecipant"
												[bootstrap]="true"
												[eid]="partecipant.id"></app-attachments>

										</ng-template>
									</ng-container>
									<ng-container ngbNavItem>
										<a ngbNavLink>Moduli</a>
										<ng-template ngbNavContent>
											<app-doc-template-generate
												[tenderid]="project.tenderid"
												[entityname]="partecipant.name"
												[entity]="partecipant.entity"
												[eid]="partecipant.id"></app-doc-template-generate>
										</ng-template>
									</ng-container>
								</nav>
								<div
									[ngbNavOutlet]="nav2"
									class="mt-2"></div>
							</ng-template>

						</ng-template>
					</ng-container>
				</ng-template>

				<ng-container
					ngbNavItem="sezioniaggiuntive"
					[disabled]="!project.id">
					<a
						routerLink="."
						fragment="sezioniaggiuntive"
						ngbNavLink>
						Sezioni aggiuntive
					</a>
					<ng-template ngbNavContent>
						<app-additional-sections
							[eid]="project.id"
							[tenderid]="project.tenderid"
							entity="project"></app-additional-sections>
					</ng-template>
				</ng-container>

				<ng-container
					ngbNavItem="rendicontazione"
					[disabled]="project.isDraft">
					<a
						routerLink="."
						fragment="rendicontazione"
						ngbNavLink>
						Rendicontazione
					</a>
					<ng-template ngbNavContent>
						<app-project-costsummary [project]="project"></app-project-costsummary>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : project.company.id}"
							[readonly]="!project?.isDraft"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="project"
							[bootstrap]="true"
							(change)="attachmentsChanged()"
							[canvalidate]="canvalidate"
							[eid]="project.id"></app-attachments>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="moduli">
					<a
						routerLink="."
						fragment="moduli"
						ngbNavLink>
						Moduli
					</a>
					<ng-template ngbNavContent>

						<app-doc-template-generate
							[tenderid]="project.tenderid"
							[entityname]="project.name"
							entity="project"
							[eid]="project.id"></app-doc-template-generate>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="gantt">
					<a
						routerLink="."
						fragment="gantt"
						ngbNavLink>
						Cronoprogramma
					</a>
					<ng-template ngbNavContent>
						<app-project-gantt [project]="project"></app-project-gantt>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.project' | translate}}
		</app-card>
	</div>
</div>

<ng-template
	#fileGeneratorModal
	let-modal>
	<div class="modal-header">
		<h4
			class="modal-title"
			id="modal-basic-title">
			{{'labels.generation-option' | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div class="modal-body">

		<ng-container *ngIf="exporting; else elseTemplate">
			<div class="row">
				<div class="col text-center">
					<app-loader [material]="false"></app-loader>
					<div class="text-center">{{'labels.generating' | translate}}</div>
				</div>
			</div>
		</ng-container>
		<ng-template #elseTemplate>
			<div
				class="row mt-3 border-bottom"
				*ngFor="let option of generatorOptions">
				<div class="col-md-6">
					<label>{{option.label | titlecase}}</label>
				</div>
				<div class="col-md-6 text-right">
					<a
						href="javascript:void(0)"
						(click)="download(option)">
						<i class="fa fa-download"></i>
					</a>
				</div>
			</div>
		</ng-template>

	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-outline-dark"
			(click)="modal.close('Save click')">
			{{'labels.close' | translate}}
		</button>
	</div>
</ng-template>
